export default __webpack_public_path__ + "static/media/package_back.68fc8060.png";